import React from 'react';

 interface ConfirmationModalProps{ 
  message:string, 
  onConfirm:any, 
  onCancel:any,
  isLoading?: boolean
 }
const ConfirmationModal = ({ message,onConfirm,onCancel, isLoading = false }: ConfirmationModalProps) => {
  return (
    <div className="fixed h-screen inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded shadow-lg">
        {/* <div className="flex justify-center mb-4">
      <img
         
            src={"/images/icon/alert-icon.png"}
            alt="alert icon"
          />
          </div> */}
        <p className=" font-bold text-black">{message}</p>
        <div className="flex space-x-8 item-center justify-center mt-6">
          <button 
            type="submit" 
            className={`text-white focus:ring-4 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center ${
              isLoading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-success hover:bg-green-700'
            }`}
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className={`text-white focus:ring-4 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center ${
              isLoading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-danger hover:bg-danger'
            }`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A8.001 8.001 0 0117.709 7H15v5.373L6.373 17H6v-4.709zM20 12h-4v-.373l-5.373-5.372L15 6.627V2h5.373A8.001 8.001 0 0120 12z"
                  ></path>
                </svg>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;